import * as yup from 'yup';

const invoiceValidationFields = {
  customer: yup
    .object()
    .shape({
      useComapnyAsCustomer: yup.boolean(),
      customer: yup.object().shape({}).nullable()
    })
    .test('If useCompanyAsCustomer is false', function (value) {
      if (!value?.useCompanyAsCustomer && !value?.customer) {
        return false;
      }
      return true;
    }),
  selectedOffers: yup
    .array()
    .of(
      yup.object().shape({
        id: yup.number().required(),
        title: yup.string().required()
      })
    )
    .min(1)
    .required(),
  selectedPeriods: yup
    .array()
    .of(
      yup.object().shape({
        id: yup.number().required(),
        price: yup.number().required()
      })
    )
    .min(1)
    .required(),
  invoiceSettings: yup.object().shape({
    tax: yup.boolean().notRequired()
  })
};

export const invoiceValidationSchema = yup.object().shape(invoiceValidationFields);

export type InvoiceFormValues = yup.InferType<typeof invoiceValidationSchema>;

// NOTE We only create invoices and do not update them!!
export const useInvoiceInitialValues = () => {
  return {
    customer: {
      useCompanyAsCustomer: true,
      customer: null
    },
    selectedOffers: [],
    selectedPeriods: [],
    invoiceSettings: {
      tax: true
    }
  };
};

export const isStepValid = (step, values) => {
  switch (step) {
    case 0:
      return invoiceValidationFields.customer.isValidSync(values.customer);
    case 1:
      return invoiceValidationFields.selectedOffers.isValidSync(values.selectedOffers);
    case 2:
      return invoiceValidationFields.selectedPeriods.isValidSync(values.selectedPeriods);
    case 3:
      return invoiceValidationFields.invoiceSettings.isValidSync(values.invoiceSettings);
    default:
      return false;
  }
};
